// extracted by mini-css-extract-plugin
export default {"no_results":"NoResults_no_results__CHCEI"};